import { search } from '../../helpers/api';

export const AUTH_SERVICE_URI = '/users';
export const AUTH_BASE_URI = '/api/v1/permissions';

export const getPermissions = async (data) =>
  search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}`, data);
